import { render, staticRenderFns } from "./input-number.vue?vue&type=template&id=9150379a&scoped=true&"
import script from "./input-number.vue?vue&type=script&lang=js&"
export * from "./input-number.vue?vue&type=script&lang=js&"
import style0 from "./input-number.vue?vue&type=style&index=0&id=9150379a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9150379a",
  null
  
)

export default component.exports